module.exports = __webpack_public_path__ + "img/273.1b490549.png";